
import React, {  } from "react";
import Chart from "react-apexcharts";

export interface RadialBarChartType {
  labels: Array<string>,
  colors: Array<string>,
  series: Array<number>,
  id: string,
}

export default function RadialBarChart({ labels, colors, series, id }: RadialBarChartType) {
  return (
    <Chart
      id={id}
      options={{
        colors: colors,
        labels: labels,
        chart: {
          width: "300",
          height: "300",
        },
        legend: {
          show: true,
          showForSingleSeries: false,
          showForNullSeries: true,
          showForZeroSeries: true,
          floating: false,
          fontSize: "8px",
          fontFamily: "Helvetica, Arial",
          offsetX: 120,
          offsetY: series.length === 2 ? -1 : -4,
          itemMargin: { horizontal: 5, vertical: series.length === 2 ? 1.5 : -2 },
          labels: {
            useSeriesColors: true
          },
          markers: {
            size: 0,
            strokeWidth: 0,
            offsetX: 0,
            offsetY: 0,
          } as any,
          onItemClick: {
            toggleDataSeries: false
          },
          onItemHover: {
            highlightDataSeries: true,
          }
        },
        plotOptions: {
          radialBar: {
            inverseOrder: false,
            startAngle: 0,
            endAngle: 275,
            offsetX: 50,
            offsetY: 0,
            hollow: {
              margin: 0,
              size: '35%',
              background: 'transparent',
              image: undefined,
              imageWidth: 150,
              imageHeight: 150,
              imageOffsetX: 0,
              imageOffsetY: 0,
              imageClipped: true,
              position: 'front',
              dropShadow: {
                enabled: false,
                top: 0,
                left: 0,
                blur: 3,
                opacity: 0.5
              }
            },
            track: {
              show: true,
              startAngle: undefined,
              endAngle: undefined,
              background: "#f2f2f2",
              strokeWidth: "97%",
              opacity: 1,
              margin: 3,
              dropShadow: {
                enabled: false,
                top: 0,
                left: 0,
                blur: 3,
                opacity: 0.5
              }
            },
            dataLabels: {
              show: true,
              name: {
                show: true,
                fontSize: "10px",
                fontWeight: 'bold',
                fontFamily: undefined,
                color: undefined,
                offsetY: 0
              },
              value: {
                show: true,
                fontSize: "8px",
                fontFamily: undefined,
                color: undefined,
                offsetY: 0
              },
              total: {
                show: false
              }
            }
          },
        },
        stroke: {
          lineCap: 'round'
        },
        responsive: [
          {
            breakpoint: 1034,
            options: {
              chart: {
                width: "300",
                height: "300",
              }
            }
          }
        ]
      }}
      series={series}
      type="radialBar"
      width={'300'}
    />
  );
}